import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Col, Glyphicon, Row, ButtonToolbar } from "react-bootstrap";
import Swal from "sweetalert2";
import toastr from "toastr";

import { FeatureKeysActivityLogsPath } from "routes/paths";
import {
  ROLENAMES,
  FEATURE_KEY_KEY
} from "provider/PermissionProvider/permissions";

import {
  GetFeatureKeys,
  UploadFeatureKey,
  DeleteFeatureKey,
  UpdateFeatureKeyStatus,
} from "./action";
import Loader from "../../Loader/index";
import { AddFeatureKeyModal } from "./add-feature-key-modal";
import { Panel, PanelHeader } from "../../Panel";
import { Filters, Filter } from "../../Filter";
import { famOption } from "../../Filter/Filters";
import { Grid } from "../../Grid";

class FeatureKeys extends Component {
  state = {
    isInitializing: false,
    showModal: false,
    selectedFamily: {
      value: -1,
      text: "",
    },
    selectedStatus: {
      value: -1,
      text: "",
    },
    isGridLoading: true,
  };

  componentDidMount() {
    this.setState({
      isInitializing: true,
    });

    this.props.GetFeatureKeys().then(() => {
      this.setState({
        isGridLoading: false,
      });
    });

    this.setState({
      isInitializing: false,
    });
  }

  toggleModal = () => {
    this.setState({ showModal: !this.state.showModal });
  };

  handleFilterValueChange = (state) => {
    this.setState({
      selectedFamily: state.family,
      selectedStatus: state.keyVersionStatus,
    });
  };

  handleUploadFeatureKey = async (values, actions) => {
    // true: enable newly uploaded feature key.
    const response = await this.props.UploadFeatureKey(
      this.state.selectedFamily.value,
      values.key,
      true
    );

    if (response.isSuccess) {
      toastr.info(`New feature key has been uploaded.`, "Upload");
      this.toggleModal();
      await this.props.GetFeatureKeys();
    } else {
      toastr.error(`${response.payload.error}`, "Error");
    }

    actions.setSubmitting(false);
  };

  handleDeleteFeatureKey = (row) => (event) => {
    Swal.fire({
      title: "Delete feature key?",
      text: `Do you really want to delete this feature key?`,
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No",
      reverseButtons: true,
      focusConfirm: false,
      focusCancel: true,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          return await this.props.DeleteFeatureKey(row.key_version);
        } catch (error) {
          Swal.fire(
            "An error has occurred",
            "An unexpected error has occurred. Please try again later.",
            "error"
          );
        }
      },
    }).then(async (response) => {
      if (response.value) {
        if (response.value.isSuccess) {
          Swal.fire("Deleted!", response.value.payload.message, "success");
          await this.props.GetFeatureKeys();
        } else {
          Swal.fire(
            "An error has occurred",
            response.value.payload.error,
            "error"
          );
        }
      }
    });
  };

  handleDisableFeatureKey = (row) => (event) => {
    Swal.fire({
      title: "Disable feature key?",
      text: `Do you really want to disable this feature key?`,
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, disable it!",
      cancelButtonText: "No",
      reverseButtons: true,
      focusConfirm: false,
      focusCancel: true,
      showLoaderOnConfirm: true,
      allowOutsideClick: () => !Swal.isLoading(),
      preConfirm: async () => {
        try {
          return await this.props.UpdateFeatureKeyStatus(
            row.key_version,
            false
          );
        } catch (error) {
          Swal.fire(
            "An error has occurred",
            "An unexpected error has occurred. Please try again later.",
            "error"
          );
        }
      },
    }).then(async (response) => {
      if (response.value) {
        if (response.value.isSuccess) {
          Swal.fire("Disabled!", response.value.payload.message, "success");
          await this.props.GetFeatureKeys();
        } else {
          Swal.fire(
            "An error has occurred",
            response.value.payload.error,
            "error"
          );
        }
      }
    });
  };

  featureKeysButtonFormatter(row) {
    if (row.is_active) {
      return (
        <Button
          bsStyle="danger"
          title="Disable Feature Key"
          onClick={this.handleDisableFeatureKey(row)}
        >
          <Glyphicon glyph="ban-circle" />
        </Button>
      );
    }

    return (
      <Button
        bsStyle="danger"
        title="Delete Feature Key"
        onClick={this.handleDeleteFeatureKey(row)}
      >
        <Glyphicon glyph="trash" />
      </Button>
    );
  }

  featureKeysRowStyle(row) {
    if (row.is_active) {
      return { backgroundColor: "rgb(17, 73, 123, 0.1)" };
    }

    return { backgroundColor: "transparent", color: "#999" };
  }

  filterFeatureKeys(unitFamily, status) {
    var data = this.props.featureKeys;

    if (unitFamily !== -1) {
      data = data.filter((item) => item.unit_family === unitFamily);
    }

    if (status !== -1) {
      data = data.filter((item) => item.is_active === Boolean(status));
    }

    return data;
  }

  render() {
    if (this.state.isInitializing) {
      return <Loader fullpage message="Loading feature keys" />;
    }

    const columns = [
      {
        dataField: "id",
        text: "Id",
        hidden: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "name",
        text: "Family",
        sort: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "created_by",
        text: "Created By",
        sort: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "created_at",
        text: "Created Date",
        sort: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "updated_by",
        text: "Updated By",
        sort: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "updated_at",
        text: "Updated Date",
        sort: true,
        style: { wordWrap: "break-word" },
        headerStyle: { wordWrap: "break-word" },
        title: (cell) => cell,
      },
      {
        dataField: "buttons",
        text: "",
        headerStyle: { width: "60px" },
        formatter: (cell, row) => this.featureKeysButtonFormatter(row),
      },
    ];

    const filteredList = this.filterFeatureKeys(
      this.state.selectedFamily.value,
      this.state.selectedStatus.value
    );
    const isAllowToAddFeatureKeys = this.state.selectedFamily.value !== -1;
    const keyVersionStatusOptions = [
      { id: -1, name: "All" },
      { id: 1, name: "Active" },
      { id: 0, name: "Inactive" },
    ];

    return (
      <div className="container-fluid">
        <h1>Feature Keys</h1>
        <Row>
          <Col md={10} mdPush={2}>
            <Panel>
              <PanelHeader>
                <ButtonToolbar>
                  <Button
                    bsSize="small"
                    bsStyle="success"
                    disabled={!isAllowToAddFeatureKeys}
                    onClick={this.toggleModal}
                  >
                    <Glyphicon glyph="plus" /> Add Feature Key
                  </Button>
                  <Button
                    bsSize="small"
                    bsStyle="primary"
                    onClick={() =>
                      this.props.history.push(FeatureKeysActivityLogsPath)
                    }
                  >
                    <Glyphicon glyph="tasks" /> View Activity Logs
                  </Button>
                </ButtonToolbar>
              </PanelHeader>
              <div className="panel-body">
                <Grid
                  columns={columns}
                  data={filteredList}
                  keyField="key_version"
                  loading={this.state.isGridLoading}
                  rowStyle={this.featureKeysRowStyle}
                />
              </div>
            </Panel>
          </Col>
          <Filters
            className="col-md-2 col-md-pull-10"
            initialValues={{ keyVersionStatus: { text: "", value: -1 } }}
            onFilterValueChange={this.handleFilterValueChange}
            familyOption={famOption.FAMILY_PACKAGES}
            roleNameId={ROLENAMES[FEATURE_KEY_KEY].id}
            hasFamily
          >
            <Filter
              name="keyVersionStatus"
              title="Key Version Status"
              options={keyVersionStatusOptions}
            />
          </Filters>
        </Row>
        <AddFeatureKeyModal
          show={this.state.showModal}
          selectedFamily={this.state.selectedFamily.text}
          onFormSubmit={this.handleUploadFeatureKey}
          onModalClose={this.toggleModal}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    families: state.configuration.families,
    featureKeys: state.productLicense.featureKeys,
  };
};

const mapDispatchToProps = {
  GetFeatureKeys,
  UploadFeatureKey,
  DeleteFeatureKey,
  UpdateFeatureKeyStatus,
};

export default connect(mapStateToProps, mapDispatchToProps)(FeatureKeys);
